export const miscConstants = {
    LOADING: 'MISC_LOADING',
    BOOKING_CONFIRMATION_OK: 'MISC_BOOKING_CONFIRMATION_OK',
    BOOKING_CONFIRMATION_FAILURE: 'MISC_BOOKING_CONFIRMATION_FAILURE',

};